(function () {
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    fmt = fmt || '£{{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function initMain(root) {
    if (root.dataset.srpReady) return;
    root.dataset.srpReady = '1';
    var fmt = root.dataset.moneyFormat;

    // Gallery
    var slides = root.querySelectorAll('.srp-slide');
    var thumbs = root.querySelectorAll('.srp-thumb');
    function show(i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(+t.dataset.slide); });
    });

    // Quantity
    var q = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + (+b.dataset.qty));
      });
    });

    // Variants
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-srp-variants]').textContent); } catch (e) {}
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var stock = root.querySelector('[data-stock]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyBtn = document.querySelector('[data-sticky] button');
    var atcText = atcLabel ? atcLabel.textContent : 'Add to cart';
    var groups = root.querySelectorAll('[data-option-index]');

    function selected() {
      var out = [];
      groups.forEach(function (g) {
        var a = g.querySelector('.srp-pill.is-active');
        out[+g.dataset.optionIndex] = a ? a.dataset.value : null;
      });
      return out;
    }
    function update() {
      var sel = selected();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!v) return;
      idInput.value = v.id;
      var p = money(v.price, fmt);
      if (priceEl) priceEl.textContent = p;
      if (atcPrice) atcPrice.textContent = p + ' ↗';
      if (stickyPrice) stickyPrice.textContent = p;
      atc.disabled = !v.available;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? atcText : 'Sold out';
      if (stock) stock.textContent = v.available ? 'In stock' : 'Sold out';
      if (v.featured_media) {
        var idx = Array.prototype.findIndex.call(slides, function (s) { return s.dataset.mediaId == v.featured_media.id; });
        if (idx > -1) show(idx);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    groups.forEach(function (g) {
      g.querySelectorAll('.srp-pill').forEach(function (p) {
        p.addEventListener('click', function () {
          g.querySelectorAll('.srp-pill').forEach(function (x) {
            x.classList.toggle('is-active', x === p);
            x.setAttribute('aria-pressed', x === p ? 'true' : 'false');
          });
          update();
        });
      });
    });

    // Selling plans
    var planWrap = root.querySelector('[data-selling-plans]');
    var planInput = root.querySelector('[data-plan-input]');
    if (planWrap && planInput) {
      planWrap.querySelectorAll('.srp-pill').forEach(function (p) {
        p.addEventListener('click', function () {
          planWrap.querySelectorAll('.srp-pill').forEach(function (x) { x.classList.toggle('is-active', x === p); });
          planInput.value = p.dataset.plan;
          planInput.disabled = !p.dataset.plan;
        });
      });
      if (!planInput.value) planInput.disabled = true;
    }

    // Free shipping progress
    var ship = root.querySelector('[data-ship]');
    var threshold = parseInt(root.dataset.freeThreshold, 10) || 0;
    function refreshShip() {
      if (!ship || !threshold) return;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = cart.total_price || 0;
          var left = threshold - total;
          var text = ship.querySelector('[data-ship-text]');
          var bar = ship.querySelector('[data-ship-bar]');
          var more = ship.dataset.more || 'Add [amount] more for free UK shipping';
          var done = ship.dataset.done || "You've got free UK shipping";
          text.innerHTML = left > 0 ? more.replace('[amount]', '<b>' + money(left, fmt) + '</b>') : done;
          bar.style.width = Math.min(100, Math.round((total / threshold) * 100)) + '%';
        }).catch(function () {});
    }
    refreshShip();
    document.addEventListener('cart:change', refreshShip);
    document.addEventListener('cart:updated', refreshShip);
    root.addEventListener('submit', function () { setTimeout(refreshShip, 1200); }, true);

    // Sticky bar
    var sticky = document.querySelector('[data-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
      }).observe(atc);
    }
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.srp-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-srp-main]').forEach(initMain);
    initReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Review slider */
  if (!customElements.get('srp-review-slider')) {
    customElements.define('srp-review-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.srp-rv-slide'));
        if (this.slides.length < 2) return;
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 2600;
        this.bar = this.querySelector('[data-rv-bar]');
        this.current = this.querySelector('[data-rv-current]');
        this.paused = false;
        this.elapsed = 0;
        this.last = null;
        var self = this;
        this.querySelector('[data-rv-next]').addEventListener('click', function () { self.go(self.index + 1); });
        this.querySelector('[data-rv-prev]').addEventListener('click', function () { self.go(self.index - 1); });
        this.addEventListener('mouseenter', function () { self.setPaused(true); });
        this.addEventListener('mouseleave', function () { self.setPaused(false); });
        this.addEventListener('focusin', function () { self.setPaused(true); });
        this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.setPaused(false); });
        this.addEventListener('touchstart', function (e) {
          if (e.target.closest('button')) return;
          self.setPaused(!self.paused);
        }, { passive: true });
        this.visible = true;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { self.visible = es[0].isIntersecting; }).observe(this);
        }
        this.last = performance.now();
        this.timer = setInterval(this.tick.bind(this), 50);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      setPaused(p) {
        this.paused = p;
        this.classList.toggle('is-paused', p);
      }
      go(i) {
        var n = this.slides.length;
        var next = (i + n) % n;
        var dir = i < this.index ? 'is-back' : '';
        this.slides[this.index].classList.remove('is-active', 'is-back');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.index = next;
        var s = this.slides[next];
        s.classList.remove('is-back');
        if (dir) s.classList.add(dir);
        s.classList.add('is-active');
        s.removeAttribute('aria-hidden');
        if (this.current) this.current.textContent = (next + 1 < 10 ? '0' : '') + (next + 1);
        this.elapsed = 0;
      }
      tick() {
        var now = performance.now();
        var dt = now - this.last;
        this.last = now;
        if (dt > 1000) dt = 0;
        if (!this.paused && this.visible && !document.hidden) {
          this.elapsed += dt;
          if (this.elapsed >= this.interval) this.go(this.index + 1);
        }
        if (this.bar) this.bar.style.transform = 'scaleX(' + Math.min(this.elapsed / this.interval, 1) + ')';
      }
    });
  }
